// // import { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import Layout from '../components/Layout';
// // import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
// // import { Badge } from '../components/ui/badge';
// // import { Input } from '../components/ui/input';
// // import { Mail, Shield } from 'lucide-react';
// // import { API } from '../App';
// // import { toast } from 'sonner';

// // export default function Users() {
// //   const [user, setUser] = useState(null);
// //   const [users, setUsers] = useState([]);
// //   const [filteredUsers, setFilteredUsers] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [searchTerm, setSearchTerm] = useState('');

// //   useEffect(() => {
// //     const storedUser = JSON.parse(localStorage.getItem('user'));
// //     setUser(storedUser);
// //     if (storedUser) {
// //       fetchUsers(storedUser);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     if (searchTerm) {
// //       const filtered = users.filter(
// //         (u) =>
// //           u.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //           u.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //           u.role.toLowerCase().includes(searchTerm.toLowerCase())
// //       );
// //       setFilteredUsers(filtered);
// //     } else {
// //       setFilteredUsers(users);
// //     }
// //   }, [searchTerm, users]);

// //   const fetchUsers = async (currentUser) => {
// //     try {
// //       let url = `${API}/users`;
// //       if (currentUser.role === 'admin') {
// //         url += `?organization_id=${currentUser.organization_id}`;
// //       }
// //       const response = await axios.get(url);
// //       setUsers(response.data);
// //       setFilteredUsers(response.data);
// //     } catch (error) {
// //       toast.error('Failed to load users');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const getRoleBadgeColor = (role) => {
// //     switch (role) {
// //       case 'super_admin':
// //         return 'bg-red-100 text-red-800';
// //       case 'admin':
// //         return 'bg-blue-100 text-blue-800';
// //       case 'developer':
// //         return 'bg-green-100 text-green-800';
// //       case 'client':
// //         return 'bg-purple-100 text-purple-800';
// //       default:
// //         return 'bg-gray-100 text-gray-800';
// //     }
// //   };

// //   if (!user) return <div>Loading...</div>;

// //   return (
// //     <Layout user={user}>
// //       <div data-testid="users-page">
// //         <div className="mb-8">
// //           <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
// //             Users
// //           </h1>
// //           <p className="text-gray-600">Manage users and their roles</p>
// //         </div>

// //         <div className="mb-6">
// //           <Input
// //             placeholder="Search users by name, email, or role..."
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //             className="max-w-md"
// //             data-testid="users-search-input"
// //           />
// //         </div>

// //         {loading ? (
// //           <div className="text-center py-12">Loading users...</div>
// //         ) : filteredUsers.length === 0 ? (
// //           <Card>
// //             <CardContent className="py-12 text-center">
// //               <p className="text-gray-500">No users found.</p>
// //             </CardContent>
// //           </Card>
// //         ) : (
// //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
// //             {filteredUsers.map((u) => (
// //               <Card key={u.id} className="hover:shadow-lg transition-shadow" data-testid={`user-card-${u.id}`}>
// //                 <CardHeader>
// //                   <div className="flex justify-between items-start">
// //                     <div className="flex items-center gap-3">
// //                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white font-bold text-lg">
// //                         {u.name.charAt(0).toUpperCase()}
// //                       </div>
// //                       <div>
// //                         <CardTitle className="text-lg">{u.name}</CardTitle>
// //                         <Badge className={`mt-1 ${getRoleBadgeColor(u.role)}`}>
// //                           {u.role.replace('_', ' ').toUpperCase()}
// //                         </Badge>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </CardHeader>
// //                 <CardContent className="space-y-2">
// //                   <div className="flex items-center text-sm text-gray-600">
// //                     <Mail className="mr-2 h-4 w-4" />
// //                     {u.email}
// //                   </div>
// //                   <div className="flex items-center text-sm text-gray-500">
// //                     <Shield className="mr-2 h-4 w-4" />
// //                     Joined {new Date(u.created_at).toLocaleDateString()}
// //                   </div>
// //                 </CardContent>
// //               </Card>
// //             ))}
// //           </div>
// //         )}
// //       </div>
// //     </Layout>
// //   );
// // }
// import { useState, useEffect } from 'react';
// import { db } from '../firebase';
// import {
//   collection,
//   getDocs,
//   query,
//   where,
//   orderBy,
// } from "firebase/firestore";

// import Layout from '../components/Layout';
// import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
// import { Badge } from '../components/ui/badge';
// import { Input } from '../components/ui/input';
// import { Mail, Shield } from 'lucide-react';
// import { toast } from 'sonner';
// import { useNavigate } from 'react-router-dom';

// export default function Users() {
//   const [user, setUser] = useState(null);
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');

//   // Load logged-in user
//  const navigate = useNavigate();

//   useEffect(() => {
//     const storedUser = JSON.parse(localStorage.getItem("user"));

//     // ❌ Wrong: 'admmin'
//     // ✔ Correct: 'admin'
//     const isAuthorized =
//       storedUser &&
//       (storedUser.role === "admin" || storedUser.role === "super_admin");

//     if (!isAuthorized) {
//       toast.error("Our AI monitoring system has automatically recorded this event.");
//       navigate("/dashboard");
//       return; // stop further execution
//     }

//     setUser(storedUser);

//     if (storedUser) {
//       fetchUsers(storedUser);
//     }
//   }, []);


//   // Search
//   useEffect(() => {
//     if (searchTerm) {
//       const filtered = users.filter(
//         (u) =>
//           u.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           u.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           u.role?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredUsers(filtered);
//     } else {
//       setFilteredUsers(users);
//     }
//   }, [searchTerm, users]);

//   // Fetch users from Firestore
//   const fetchUsers = async (currentUser) => {
//     console.log("users users" , currentUser.role)
//     try {
//       let q;

//       if (currentUser.role == "admin" || currentUser.role == "super_admin") {
//         // Admin sees users in same organization
//         // q = query(
//         //   collection(db, "users"),
//         //   where("organization_id", "==", currentUser.organization_id),
//         //   orderBy("createdAt", "desc")
//         // );
//           q = query(
//           collection(db, "users"),
//           orderBy("createdAt", "desc")
//         );
//       } else {
//         // Super admin sees all users
    
//       }

//       const snapshot = await getDocs(q);

//       const data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       setUsers(data);
//       setFilteredUsers(data);

//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to load users from Firebase");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Role color badge
//   const getRoleBadgeColor = (role) => {
//     switch (role) {
//       case 'super_admin': return 'bg-red-100 text-red-800';
//       case 'admin': return 'bg-blue-100 text-blue-800';
//       case 'developer': return 'bg-green-100 text-green-800';
//       case 'client': return 'bg-purple-100 text-purple-800';
//       default: return 'bg-gray-100 text-gray-800';
//     }
//   };

//   if (!user) return <div>Loading...</div>;

//   return (
//     <Layout user={user}>
//       <div data-testid="users-page">
//         <div className="mb-8">
//           <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
//             Users
//           </h1>
//           <p className="text-gray-600">Manage users and their roles</p>
//         </div>

//         <div className="mb-6">
//           <Input
//             placeholder="Search users by name, email, or role..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="max-w-md"
//           />
//         </div>

//         {!(user.role == 'super_admin' || user.role == 'admin') ?
//             <Card>
//             <CardContent className="py-12 text-center">
//               <p className="text-gray-500">Access denied — unauthorized action.</p>
//               <p className="text-gray-500">Our AI monitoring system has automatically recorded this event.</p>

//             </CardContent>
//           </Card> :
        
//         loading ? (
//           <div className="text-center py-12">Loading users...</div>
//         ) : filteredUsers.length === 0 ? (
//           <Card>
//             <CardContent className="py-12 text-center">
//               <p className="text-gray-500">No users found.</p>
//             </CardContent>
//           </Card>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {filteredUsers.map((u) => (
//               <Card key={u.id} className="hover:shadow-lg transition-shadow">
//                 <CardHeader>
//                   <div className="flex justify-between items-start">
//                     <div className="flex items-center gap-3">
//                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white font-bold text-lg">
//                         {u.name?.charAt(0)?.toUpperCase()}
//                       </div>
//                       <div>
//                         <CardTitle className="text-lg">{u.name}</CardTitle>
//                         <Badge className={`mt-1 ${getRoleBadgeColor(u.role)}`}>
//                           {u.role?.replace('_', ' ').toUpperCase()}
//                         </Badge>
//                       </div>
//                     </div>
//                   </div>
//                 </CardHeader>

//                 <CardContent className="space-y-2">
//                   {/* Email */}
//                   <div className="flex items-center text-sm text-gray-600">
//                     <Mail className="mr-2 h-4 w-4" />
//                     {u.email}
//                   </div>

//                   {/* Joined Date */}
//                   <div className="flex items-center text-sm text-gray-500">
//                     <Shield className="mr-2 h-4 w-4" />
//                     Joined{" "}
//                     {u.createdAt
//                       ? new Date(u.createdAt.toDate()).toLocaleDateString()
//                       : "—"}
//                   </div>
//                 </CardContent>
//               </Card>
//             ))}
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// }
// import { useState, useEffect } from 'react';
// import { db, auth } from '../firebase';
// import {
//   collection,
//   getDocs,
//   query,
//   where,
//   orderBy,
//   doc,
//   updateDoc,
// } from "firebase/firestore";
// import { sendPasswordResetEmail } from 'firebase/auth';

// import Layout from '../components/Layout';
// import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
// import { Badge } from '../components/ui/badge';
// import { Input } from '../components/ui/input';
// import { Button } from '../components/ui/button';
// import { Mail, Shield, Lock } from 'lucide-react';
// import { toast } from 'sonner';
// import { useNavigate } from 'react-router-dom';

// export default function Users() {
//   const [user, setUser] = useState(null);
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');

//   const navigate = useNavigate();
// // Verify user account
// const handleVerifyUser = async (userId) => {
//   try {
//     const userRef = doc(db, "users", userId);
//     await updateDoc(userRef, { verify: true });
//     toast.success("User verified successfully");
//     // Refresh user list
//     fetchUsers(user);
//   } catch (error) {
//     console.error(error);
//     toast.error("Failed to verify user");
//   }
// };

//   useEffect(() => {
//     const storedUser = JSON.parse(localStorage.getItem("user"));

//     const isAuthorized =
//       storedUser &&
//       (storedUser.role === "admin" || storedUser.role === "super_admin");

//     if (!isAuthorized) {
//       toast.error("Our AI monitoring system has automatically recorded this event.");
//       navigate("/dashboard");
//       return;
//     }

//     setUser(storedUser);
//     if (storedUser) fetchUsers(storedUser);
//   }, []);

//   useEffect(() => {
//     if (searchTerm) {
//       const filtered = users.filter(
//         u =>
//           u.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           u.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           u.role?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredUsers(filtered);
//     } else {
//       setFilteredUsers(users);
//     }
//   }, [searchTerm, users]);

//   // Fetch users from Firestore
//   const fetchUsers = async (currentUser) => {
//     try {
//       const q = query(
//         collection(db, "users"),
//         orderBy("createdAt", "desc")
//       );
//       const snapshot = await getDocs(q);
//       const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//       setUsers(data);
//       setFilteredUsers(data);
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to load users from Firebase");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getRoleBadgeColor = (role) => {
//     switch (role) {
//       case 'super_admin': return 'bg-red-100 text-red-800';
//       case 'admin': return 'bg-blue-100 text-blue-800';
//       case 'developer': return 'bg-green-100 text-green-800';
//       case 'client': return 'bg-purple-100 text-purple-800';
//       default: return 'bg-gray-100 text-gray-800';
//     }
//   };

//   // Reset password for user
//   const handleResetPassword = async (email) => {
//     try {
//       await sendPasswordResetEmail(auth, email);
//       toast.success(`Password reset email sent to ${email}`);
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to send password reset email");
//     }
//   };

//   // Suspend / Unsuspend user login
//   const handleToggleSuspend = async (userId, currentStatus) => {
//     try {
//       const userRef = doc(db, "users", userId);
//       await updateDoc(userRef, { suspended: !currentStatus });
//       toast.success(`User ${!currentStatus ? "suspended" : "unsuspended"} successfully`);
//       // Refresh users list
//       fetchUsers(user);
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to update user status");
//     }
//   };

//   if (!user) return <div>Loading...</div>;

//   return (
//     <Layout user={user}>
//       <div data-testid="users-page">
//         <div className="mb-8">
//           <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
//             Users
//           </h1>
//           <p className="text-gray-600">Manage users and their roles</p>
//         </div>

//         <div className="mb-6">
//           <Input
//             placeholder="Search users by name, email, or role..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="max-w-md"
//           />
//         </div>

//         {!(user.role === 'super_admin' || user.role === 'admin') ? (
//           <Card>
//             <CardContent className="py-12 text-center">
//               <p className="text-gray-500">Access denied — unauthorized action.</p>
//               <p className="text-gray-500">Our AI monitoring system has automatically recorded this event.</p>
//             </CardContent>
//           </Card>
//         ) : loading ? (
//           <div className="text-center py-12">Loading users...</div>
//         ) : filteredUsers.length === 0 ? (
//           <Card>
//             <CardContent className="py-12 text-center">
//               <p className="text-gray-500">No users found.</p>
//             </CardContent>
//           </Card>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {filteredUsers.map((u) => (
//               <Card key={u.id} className="hover:shadow-lg transition-shadow">
//                 <CardHeader>
//                   <div className="flex justify-between items-start">
//                     <div className="flex items-center gap-3">
//                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white font-bold text-lg">
//                         {u.name?.charAt(0)?.toUpperCase()}
//                       </div>
                      
//                       <div>
//                         <CardTitle className="text-lg">{u.name}</CardTitle>
//                         <Badge className={`mt-1 ${getRoleBadgeColor(u.role)}`}>
//                           {u.role?.replace('_', ' ').toUpperCase()}
//                         </Badge>
//                       </div>
//                     </div>
//                   </div>
//                 </CardHeader>

//                 <CardContent className="space-y-2">
//                   {/* Email */}
//                   <div className="flex items-center text-sm text-gray-600">
//                     <Mail className="mr-2 h-4 w-4" />
//                     {u.email}
//                   </div>

//                   {/* Joined Date */}
//                   <div className="flex items-center text-sm text-gray-500">
//                     <Shield className="mr-2 h-4 w-4" />
//                     Joined {u.createdAt ? new Date(u.createdAt.toDate()).toLocaleDateString() : "—"}
//                   </div>

//                   {/* Actions */}
//                   <div className="flex gap-2 mt-3">
//   {!u.verify && (
//     <Button
//       variant="success"
//       size="sm"
//       onClick={() => handleVerifyUser(u.id)}
//     >
//       Verify User
//     </Button>
//   )}

//                     <Button
//                       variant="outline"
//                       size="sm"
//                       onClick={() => handleResetPassword(u.email)}
//                     >
//                       <Lock className="mr-1 h-4 w-4" />
//                       Reset Password
//                     </Button>

//                     <Button
//                       variant={u.suspended ? "destructive" : "secondary"}
//                       size="sm"
//                       onClick={() => handleToggleSuspend(u.id, u.suspended)}
//                     >
//                       {u.suspended ? "Unsuspend" : "Suspend"} Login
//                     </Button>
//                   </div>
                  
//                 </CardContent>
//               </Card>
//             ))}
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// }
import { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  doc,
  updateDoc,
} from "firebase/firestore";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";

import Layout from "../components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Mail, Shield, Lock, Phone, Edit } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../components/ui/dialog";

const ROLE_OPTIONS = ["client", "developer", "admin", "super_admin"];

export default function Users() {
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editName, setEditName] = useState("");
  const [editCountryCode, setEditCountryCode] = useState("");
  const [editPhone, setEditPhone] = useState("");

  const navigate = useNavigate();

  const handleOpenEditModal = (u) => {
    setEditingUser(u);
    setEditName(u.name || "");
    setEditCountryCode(u.countryCode || "");
    setEditPhone(u.phone || "");
    setEditDialogOpen(true);
  };

  const handleSaveUser = async (e) => {
    e.preventDefault();
    if (!editName.trim()) {
      toast.error("Name is required");
      return;
    }

    try {
      const userRef = doc(db, "users", editingUser.id);
      await updateDoc(userRef, {
        name: editName.trim(),
        countryCode: editCountryCode.trim(),
        phone: editPhone.trim(),
      });
      toast.success("User updated successfully");
      setEditDialogOpen(false);
      fetchUsers();
    } catch (error) {
      console.error(error);
      toast.error("Failed to update user");
    }
  };

  /* -------------------- AUTH CHECK -------------------- */
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    const isAuthorized =
      storedUser &&
      (storedUser.role === "admin" || storedUser.role === "super_admin");

    if (!isAuthorized) {
      toast.error(
        "Our AI monitoring system has automatically recorded this event."
      );
      navigate("/dashboard");
      return;
    }

    setUser(storedUser);
    fetchUsers();
  }, []);

  /* -------------------- SEARCH FILTER -------------------- */
  useEffect(() => {
    if (!searchTerm) {
      setFilteredUsers(users);
      return;
    }

    const term = searchTerm.toLowerCase();
    setFilteredUsers(
      users.filter(
        (u) =>
          u.name?.toLowerCase().includes(term) ||
          u.email?.toLowerCase().includes(term) ||
          u.role?.toLowerCase().includes(term)
      )
    );
  }, [searchTerm, users]);

  /* -------------------- FETCH USERS -------------------- */
  const fetchUsers = async () => {
    try {
      const q = query(collection(db, "users"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setUsers(data);
      setFilteredUsers(data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  /* -------------------- HELPERS -------------------- */
  const getRoleBadgeColor = (role) => {
    switch (role) {
      case "super_admin":
        return "bg-red-100 text-red-800";
      case "admin":
        return "bg-blue-100 text-blue-800";
      case "developer":
        return "bg-green-100 text-green-800";
      case "client":
        return "bg-purple-100 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  /* -------------------- ACTIONS -------------------- */
  const handleVerifyUser = async (userId) => {
    try {
      await updateDoc(doc(db, "users", userId), { verify: true });
      toast.success("User verified");
      fetchUsers();
    } catch {
      toast.error("Verification failed");
    }
  };

  const handleResetPassword = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success(`Password reset email sent`);
    } catch {
      toast.error("Failed to send reset email");
    }
  };

  const handleToggleSuspend = async (userId, status) => {
    try {
      await updateDoc(doc(db, "users", userId), {
        suspended: !status,
      });
      toast.success(`User ${status ? "unsuspended" : "suspended"}`);
      fetchUsers();
    } catch {
      toast.error("Failed to update status");
    }
  };

  const handleUpdateRole = async (userId, newRole) => {
    try {
      await updateDoc(doc(db, "users", userId), { role: newRole });
      toast.success("User role updated");
      fetchUsers();
    } catch {
      toast.error("Role update failed");
    }
  };

  if (!user) return <div>Loading...</div>;

  /* -------------------- RENDER -------------------- */
  return (
    <Layout user={user}>
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2">Users</h1>
        <p className="text-gray-600">Manage users and permissions</p>
      </div>

      <Input
        className="max-w-md mb-6"
        placeholder="Search by name, email or role..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {loading ? (
        <div className="text-center py-12">Loading users...</div>
      ) : filteredUsers.length === 0 ? (
        <Card>
          <CardContent className="py-12 text-center text-gray-500">
            No users found
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredUsers.map((u) => (
            <Card key={u.id} className="hover:shadow-lg transition">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white font-bold">
                    {u.name?.charAt(0)?.toUpperCase()}
                  </div>
                  <div>
                    <CardTitle>{u.name}</CardTitle>
                    <Badge className={getRoleBadgeColor(u.role)}>
                      {u.role?.replace("_", " ").toUpperCase()}
                    </Badge>
                  </div>
                </div>
              </CardHeader>

              <CardContent className="space-y-3">
                <div className="flex items-center text-sm text-gray-600">
                  <Mail className="h-4 w-4 mr-2" />
                  {u.email}
                </div>

                {u.phone && (
                  <div className="flex items-center text-sm text-gray-600">
                    <Phone className="h-4 w-4 mr-2" />
                    {u.countryCode ? `${u.countryCode} ` : ""}{u.phone}
                  </div>
                )}

                <div className="flex items-center text-sm text-gray-500">
                  <Shield className="h-4 w-4 mr-2" />
                  Joined{" "}
                  {u.createdAt
                    ? new Date(u.createdAt.toDate()).toLocaleDateString()
                    : "-"}
                </div>

                {/* ROLE UPDATE */}
                <select
                  value={u.role}
                  onChange={(e) => handleUpdateRole(u.id, e.target.value)}
                  className="w-full border rounded px-2 py-1 text-sm"
                  disabled={
                    u.role === "super_admin" && user.role !== "super_admin"
                  }
                >
                  {ROLE_OPTIONS.map((role) => (
                    <option key={role} value={role}>
                      {role.replace("_", " ").toUpperCase()}
                    </option>
                  ))}
                </select>

                <div className="flex flex-wrap gap-2 pt-2">
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => handleOpenEditModal(u)}
                  >
                    <Edit className="h-4 w-4 mr-1" />
                    Edit
                  </Button>

                  {!u.verify && (
                    <Button
                      size="sm"
                      variant="success"
                      onClick={() => handleVerifyUser(u.id)}
                    >
                      Verify
                    </Button>
                  )}

                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => handleResetPassword(u.email)}
                  >
                    <Lock className="h-4 w-4 mr-1" />
                    Reset
                  </Button>

                  <Button
                    size="sm"
                    variant={u.suspended ? "destructive" : "secondary"}
                    onClick={() => handleToggleSuspend(u.id, u.suspended)}
                  >
                    {u.suspended ? "Unsuspend" : "Suspend"}
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      {/* EDIT USER DIALOG */}
      <Dialog open={editDialogOpen} onOpenChange={setEditDialogOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Edit User Details</DialogTitle>
            <DialogDescription>
              Update name and phone number for {editingUser?.email}.
            </DialogDescription>
          </DialogHeader>

          <form onSubmit={handleSaveUser} className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="edit-name">Name</Label>
              <Input
                id="edit-name"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
                placeholder="User's Name"
                required
              />
            </div>

            <div className="grid grid-cols-4 gap-2">
              <div className="col-span-1">
                <Label htmlFor="edit-country-code">Code</Label>
                <Input
                  id="edit-country-code"
                  value={editCountryCode}
                  onChange={(e) => setEditCountryCode(e.target.value)}
                  placeholder="+1"
                />
              </div>
              <div className="col-span-3">
                <Label htmlFor="edit-phone">Phone Number</Label>
                <Input
                  id="edit-phone"
                  value={editPhone}
                  onChange={(e) => setEditPhone(e.target.value)}
                  placeholder="1234567890"
                />
              </div>
            </div>

            <DialogFooter className="pt-4">
              <Button type="button" variant="outline" onClick={() => setEditDialogOpen(false)}>
                Cancel
              </Button>
              <Button type="submit">
                Save Changes
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
